import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';

function Timings() {
  // Animation triggers when elements come into view
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    <div id="classes" className="timings section-padding" ref={ref} style={{ backgroundColor: 'transparent' }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <div className={`section-title text-center ${inView ? 'animate__animated animate__fadeInDown' : ''}`}>
              <h2>Class Schedule</h2>
              <p>Find the perfect time for your practice</p>
            </div>
          </Col>
        </Row>
        
        <div className={`schedule-container ${inView ? 'animate__animated animate__fadeInUp' : ''}`}>
          <div className="time-slot">
            <div className="time-header">
              <div className="time-badge">
                <i className="fa fa-clock-o" aria-hidden="true"></i>
                <span>Weekly Schedule (Monday to Friday)</span>
              </div>
            </div>
            
            <div className="classes-container">
              <Row className="schedule-grid">
                <Col lg={6} md={6} className="schedule-period morning">
                  <div className="period-header">
                    <i className="fa fa-sun-o"></i>
                    <h3 style={{paddingBottom:0}}>Morning Sessions</h3>
                  </div>
                  <div className="time-slots">
                    <div className="time-block">
                      <div className="time-info">
                        <span className="time">7:00 AM - 8:00 AM</span>
                        <span className="class-name">Morning Yoga</span>
                      </div>
                      <div className="time-details">
                        <span className="level-badge">All Levels</span>
                      </div>
                    </div>
                    <div className="time-block">
                      <div className="time-info">
                        <span className="time">8:00 AM - 9:00 AM</span>
                        <span className="class-name">Morning Flow</span>
                      </div>
                      <div className="time-details">
                        <span className="level-badge">All Levels</span>
                      </div>
                    </div>
                  </div>
                </Col>
                
                <Col lg={6} md={6} className="schedule-period evening">
                  <div className="period-header">
                    <i className="fa fa-moon-o"></i>
                    <h3 style={{paddingBottom:0}}>Afternoon/Evening Sessions</h3>
                  </div>
                  <div className="time-slots">
                    <div className="time-block">
                      <div className="time-info">
                        <span className="time">4:00 PM - 5:00 PM</span>
                        <span className="class-name">Afternoon Yoga</span>
                      </div>
                      <div className="time-details">
                        <span className="level-badge">All Levels</span>
                      </div>
                    </div>
                    <div className="time-block">
                      <div className="time-info">
                        <span className="time">5:00 PM - 6:00 PM</span>
                        <span className="class-name">Evening Flow</span>
                      </div>
                      <div className="time-details">
                        <span className="level-badge">All Levels</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        
        <Row className="justify-content-center mt-5">
          <Col md={8} className="text-center">
            <div className="schedule-note-wrapper">
              <i className="fa fa-info-circle note-icon"></i>
              <p className="schedule-note">
                Private sessions available upon request. Please contact us for availability.
              </p>
            </div>
            <a href="#contact" className="schedule-cta">
              Book Your Class
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Timings;
